var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.logs.list),function(log){return _c('p',{key:log.timestamp},[_vm._v(" "+_vm._s(_vm.moment(log.date).locale('ru').format('DD.MM.YYYY HH:mm'))+" "+_vm._s(' ')+" "+_vm._s(log.newStatus.name)+" "+_vm._s(log.shownName ? ' (' + log.shownName + ')' : '')+" "+_vm._s(log.description ? ' (' + log.description + ')' : '')+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }